<template>
  <div id="vue-app">
    <!-- Header & Navbar -->
    <div
      class="app-flex"
    >
      <div
        class="top-mobile-border"
        v-if="serverConfig.view == 'mobile'"
      />
      <div
        id="header"
        class="header-dark"
      >
        <div
          id="navbar-background"
          :class="navbarBackgroundClass"
        />
        <div
          class="navbar"
          justify="start"
        >
          <div
            id="Nav"
          >
            <div
              class="top-bar-flex"
            >
              <div class="flex-row-grow">
                <Burger />
                <div
                  class="brand-logo"
                  @click="gotoPath('')"
                >
                  Enbarr<span class="brand-ai">.ai</span>
                </div>
              </div>
              <div class="center-end">
                <div class="flex-row-center">
                  <div class="lang-picker" v-if="serverConfig.view != 'mobile'">
                    <div class="lang-current" @click="langMenuOpen = !langMenuOpen">
                      {{ currentLangLabel }}
                    </div>
                    <div class="lang-dropdown" v-if="langMenuOpen">
                      <div
                        v-for="l in langOptions"
                        :key="l.code"
                        class="lang-option"
                        :class="{ 'lang-active': l.code === currentLang }"
                        @click="switchLang(l.code)"
                      >
                        {{ l.label }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="theme-toggle"
                    @click="toggleTheme"
                    v-html="serverConfig.visualMode === 'dark' ? getRawIcon('ICON_SUN') : getRawIcon('ICON_MOON')"
                  />
                  <div
                    class="menu-items"
                    v-if="serverConfig.view != 'mobile'"
                    @click="gotoPath('technology')"
                  >
                    <div class="navbar-item">
                      {{localize('TEXT_TECHNOLOGY')}}
                    </div>
                  </div>
                  <div
                    class="menu-items"
                    v-if="serverConfig.view != 'mobile'"
                    @click="gotoPath('breaches')"
                  >
                    <div class="navbar-item">
                      {{localize('TEXT_BREACHES')}}
                    </div>
                  </div>
                  <div
                    class="menu-items"
                    v-if="serverConfig.view != 'mobile'"
                    @click="gotoPath('docs')"
                  >
                    <div class="navbar-item">
                      {{localize('TEXT_DOCS')}}
                    </div>
                  </div>
                  <div
                    class="menu-items"
                    v-if="userInfo?.authorized == false"
                    @click="showLoginModal = true"
                  >
                    <div
                      class="flex-col-app-center"
                    >
                      <div
                        class="navbar-item"
                      >
                        {{localize('TEXT_LOGIN')}}
                      </div>
                    </div>
                  </div>
                  <div
                    class="menu-items profile-wrap"
                    v-if="userInfo.authorized == true"
                    ref="profileWrap"
                  >
                    <button
                      type="button"
                      class="app-profile-frame"
                      :class="{ 'is-open': isMenuVisible }"
                      :aria-expanded="isMenuVisible ? 'true' : 'false'"
                      aria-haspopup="menu"
                      :aria-label="localize('TEXT_ACCOUNT')"
                      @click.stop="toggleMenu"
                    >
                      <div
                        id="app-profile-image"
                        class="profile-icon"
                        :class="{ 'profile-icon-empty': !hasProfileImage }"
                        :style="profileImageStyle"
                      >
                        <i
                          v-if="!hasProfileImage"
                          class="profile-knight"
                          aria-hidden="true"
                        />
                      </div>
                    </button>
                    <div
                      class="profile-menu"
                      :class="{ 'show-menu': isMenuVisible }"
                      role="menu"
                    >
                      <div class="profile-menu-who" v-if="accountName">
                        {{ accountName }}
                      </div>
                      <button
                        type="button"
                        class="menu-item-text"
                        role="menuitem"
                        v-if="isAdmin"
                        @click.stop="goFromMenu('licences')"
                      >
                        {{ localize('TEXT_LICENCES') }}
                      </button>
                      <button
                        type="button"
                        class="menu-item-text menu-item-quiet"
                        role="menuitem"
                        @click.stop="logoutFromMenu"
                      >
                        {{ localize('TEXT_LOGOUT') }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="app-container">

        <Sidebar class="sidebar">
          <template #mobile>
            <div class="sidebar-panel-nav">
              <div>
                <div
                  class="nav-tab-no-mobile"
                  @click="gotoTab('home')"
                >
                  {{ localize('TEXT_HOME') }}
                </div>
              </div>
              <div>
                <div
                  class="nav-tab-no-mobile"
                  @click="gotoPath('technology')"
                >
                  {{ localize('TEXT_TECHNOLOGY') }}
                </div>
              </div>
              <div>
                <div
                  class="nav-tab-no-mobile"
                  @click="gotoPath('breaches')"
                >
                  {{ localize('TEXT_BREACHES') }}
                </div>
              </div>
              <div>
                <div
                  class="nav-tab-no-mobile"
                  @click="gotoPath('docs')"
                >
                  {{ localize('TEXT_DOCS') }}
                </div>
              </div>
              <div
                v-if="userInfo.authorized == false"
              >
                <div
                  class="nav-tab-no-mobile"
                  @click="showLoginModal = true"
                >
                  {{ localize('TEXT_CONNECT') }}
                </div>
              </div>
              <div
                v-if="userInfo.authorized == true"
              >
                <div
                  class="nav-tab-no-mobile"
                  @click="doLogout"
                >
                  {{ localize('TEXT_LOGOUT') }}
                </div>
              </div>
            </div>
          </template>
          <template #desktop-compact>
            <div class="desktop-compact">
            </div>
          </template>
          <template #desktop-expand>
            <div class="desktop-expand">
            </div>
          </template>
        </Sidebar>

        <div :key="$route.path" :class="contentClass">

          <Transition
            name="route"
            mode="out-in"
          >
            <router-view v-slot="{Component}">
              <component
                class="component-margin"
                v-if="$route.path"
                :is="Component"
                :key="$route.fullPath"
              />
            </router-view>
          </Transition>
        </div>
      </div>
      <SVFooter
        @showTerms="showTermsModal = true"
        class="app-footer"
      />
    </div>

    <Transition name="modal">
      <div
        v-if="showLoginModal"
        class="modal-overlay"
        @click.self="showLoginModal = false"
      >
        <div class="modal-container">
          <div class="modal-header">
            <div> {{ localize('TEXT_LOGIN') }} </div>
            <div class="modal-close" @click="showLoginModal = false">&times;</div>
          </div>
          <div class="modal-body">
            <div class="flex-col">
              <Login
                @hide-modal-event="showLoginModal = false"
                @get-userinfo-event="emitAppEvent('getUserInfo')"
              />
            </div>
          </div>
        </div>
      </div>
    </Transition>

  </div>
</template>

<script>
import {inject, nextTick, onBeforeMount, onBeforeUnmount, onMounted, reactive, ref, watch, computed} from "vue";
import {useRoute, useRouter} from "vue-router";
import Axios from "axios";
import Burger from "./components/Burger.vue";
import SVFooter from "./components/SVFooter.vue";
import Sidebar from "./components/Sidebar.vue";
import Login from "./components/Login.vue";
import {iconStore} from "@/stores/icon";
import {mutations} from "@/stores/sidebar.js";
import {translationStore, RTL_LANGS} from "@/stores/translation";


export default {
    "name": "App",
    components: {
        Burger,
        Sidebar,
        SVFooter,
        Login
    },
    setup (_, {emit}) {

        const eBus = inject("eBus"),
            contentClass = ref(""),
            emitAppEvent = (e, d) => {

                eBus.emit(
                    "app-event",
                    {
                        "action": e,
                        "data": d
                    }
                );

            },
            name = ref(""),
            email = ref(""),
            navMenu = ref("menu-container"),
            isMenuVisible = ref(false),
            icon = iconStore(),
            lastScrollPosition = ref(0),
            navbarBackgroundClass = ref("navbar-background-tall"),
            selectedProvider = ref(),
            userProfile = inject("profile"),
            route = useRoute(),
            router = useRouter(),
            serverConfig = inject("serverConfig"),
            showTermsModal = ref(false),
            showLoginModal = ref(false),
            translation = translationStore(),
            userInfo = inject("userInfo"),
            walletText = ref("wallet-text-desktop"),
            web3 = inject("web3"),
            eth = inject("eth"),
            profileWrap = ref(null),
            isAdmin = ref(false),
            // The menu opens on a click rather than on hover. On hover it was
            // unreachable: it is positioned below the avatar, so moving the
            // pointer towards it left the element that was listening and the
            // menu closed before it could be clicked.
            toggleMenu = function () {

                isMenuVisible.value = !isMenuVisible.value;

            },
            closeMenu = function () {

                isMenuVisible.value = false;

            },
            // A click anywhere else closes it, which is what a menu that opens
            // on a click has to do — there is no pointer leaving to end it.
            onDocumentClick = function (e) {

                if (!isMenuVisible.value) { return; }
                if (profileWrap.value && profileWrap.value.contains(e.target)) { return; }
                closeMenu();

            },
            onDocumentKey = function (e) {

                if (e.key === "Escape") { closeMenu(); }

            },
            accountName = computed(() => userInfo?.email || userInfo?.username || ""),
            goFromMenu = function (path) {

                closeMenu();
                router.push(`/${path}`);

            },
            checkAdmin = function () {

                if (userInfo?.authorized !== true) {

                    isAdmin.value = false;
                    return;

                }
                Axios.get(`${process.env.VUE_APP_SERVER_URI}api/amIAdmin`).
                    then((r) => {

                        isAdmin.value = r.data?.admin === true;

                    }).
                    catch(() => {

                        isAdmin.value = false;

                    });

            },
            hasProfileImage = computed(() => Boolean(userProfile.value?.image)),
            profileImageStyle = computed(() => {

                if (userProfile.value?.image) {
                    return {
                        backgroundImage: `url(${process.env.VUE_APP_SERVER_URI}${userProfile.value.image})`,
                        borderRadius: "50%",
                        backgroundSize: "cover",
                        backgroundRepeat: "no-repeat",
                        backgroundPosition: "center",
                    };
                }
                return {};

            }),
            metamaskLogin = function () {

                localStorage.setItem(
                    "selectedProvider",
                    "metamask"
                );

                emitAppEvent(
                    "getWeb3",
                    "login"
                );

            },
            logoutFromMenu = function () {

                closeMenu();
                doLogout();

            },
            doLogout = function () {

                Axios.get(
                    `${process.env.VUE_APP_SERVER_URI}/logout`,
                    {
                    }
                ).
                    then((response) => {

                        if (response.data) {

                            emitAppEvent("getUserInfo");

                        }

                    });

            },
            getURL = function (endpoint) {

                return `${process.env.VUE_APP_SERVER_URI + endpoint}`;

            },
            getIcon = function (i) {

                if (serverConfig.visualMode === "dark") {

                    return icon.get(`${i}_DARK`);

                }
                return icon.get(`${i}_LIGHT`);

            },
            getRawIcon = function (i) {

                return icon.get(`${i}`);

            },
            langMenuOpen = ref(false),
            currentLang = ref(translation.VUE_APP_USER_LANGUAGE || "en"),
            langOptions = [
                { code: "en", label: "EN" },
                { code: "ja", label: "JA" },
                { code: "es", label: "ES" },
                { code: "fr", label: "FR" },
                { code: "zh", label: "ZH" },
                { code: "zh-TW", label: "繁中" },
                { code: "de", label: "DE" },
                { code: "ar", label: "AR" }
            ],
            currentLangLabel = computed(() => {
                var opt = langOptions.find(l => l.code === currentLang.value);
                return opt ? opt.label : "EN";
            }),
            switchLang = function (code) {
                var url = new URL(window.location);
                url.searchParams.set("lr", code);
                window.location.href = url.toString();
            },
            toggleTheme = function () {

                const newMode = serverConfig.visualMode === "dark" ? "light" : "dark";
                serverConfig.visualMode = newMode;
                localStorage.setItem("enbarr-theme", newMode);
                if (newMode === "dark") {
                    document.documentElement.setAttribute("data-theme", "dark");
                    document.querySelector('meta[name="theme-color"]').setAttribute("content", "#0a0a0f");
                } else {
                    document.documentElement.removeAttribute("data-theme");
                    document.querySelector('meta[name="theme-color"]').setAttribute("content", "#f5f5fa");
                }
                handleScroll();

            },
            gotoTab = function (t) {

                if (t === "home" && serverConfig.view === "mobile") {

                    mutations.toggleMobileNav();

                }
                router.push({"name": t,
                    "path": `/${t}`}).catch((err) => {

                    throw err;

                });

            },
            gotoPath = function (t) {

                router.push({"path": `/${t}`}).catch((err) => {

                    throw err;

                });

            },
            handleScroll = function () {

                const n = document.getElementById("navbar-background"),
                    h = document.getElementById("header"),
                    s = window.scrollY,
                    getThemeVar = (v) => getComputedStyle(document.documentElement).getPropertyValue(v).trim();

                if (s > lastScrollPosition.value && s > 50) {

                    h.style.top = "-0px";
                    navbarBackgroundClass.value = "navbar-background-short";

                } else {

                    h.style.top = "0px";
                    navbarBackgroundClass.value = "navbar-background-tall";

                }

                if (s < 50) {

                    n.style.backgroundColor = getThemeVar("--bg-navbar");
                    if (window.innerWidth <= 768) {
                        n.style.height = "150px"
                    } else {
                      n.style.height = "80px"
                    }

                } else {

                    if (window.innerWidth <= 768) {
                        n.style.height = "150px"
                    } else {
                      n.style.height = "80px"
                    }
                    n.style.backgroundColor = getThemeVar("--bg-navbar-scroll");

                }
                lastScrollPosition.value = s;

            },
            updateView = function () {

                if (serverConfig.view === "desktop") {

                    contentClass.value = "desktop-content";
                    walletText.value = "wallet-text-desktop";

                } else if (serverConfig.view === "tablet") {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-desktop";

                } else if (serverConfig.view === "mobile") {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-mobile";

                } else {

                    contentClass.value = "mobile-content";
                    walletText.value = "wallet-text-mobile";

                }

            };

        onBeforeMount(() => {

            document.title = "Enbarr.ai";

        });

        onMounted(() => {

            document.addEventListener("click", onDocumentClick);
            document.addEventListener("keydown", onDocumentKey);
            checkAdmin();

            if (route.path == 'login/') {

                showLoginModal.value = true;

            }

            // Force LTR on document — RTL only on specific text containers via .is-rtl class
            var initLang = translation.VUE_APP_USER_LANGUAGE || currentLang.value;
            document.documentElement.setAttribute("lang", initLang);
            document.documentElement.setAttribute("dir", "ltr");
            if (RTL_LANGS.indexOf(initLang) !== -1) {
                document.documentElement.classList.add("is-rtl");
            }

            updateView();
            handleScroll();

            nextTick(async () => {

                await router.isReady();

                window.addEventListener(
                    "scroll",
                    handleScroll
                );

                if (route.query.hl) {

                    translation.setLanguage(route.query.hl);

                }

                if (route.query.ha) {

                    if (route.query.ha === "login") {

                        showLoginModal.value = true;

                    }

                }

            });

            eBus.on(
                "app-event",
                (e) => {

                    switch (e.action) {

                    case "showLoginModal":
                        showLoginModal.value = true;

                    }

                }
            );

            watch(
                () => route.name,
                () => {

                    updateView();
                    closeMenu();

            });

            watch(
                () => serverConfig.view,
                () => {

                    updateView();

            });

            watch(
                () => userInfo.authorized,
                () => {

                    selectedProvider.value = localStorage.getItem("selectedProvider");

                    if (userInfo.authorized === true) {

                        showLoginModal.value = false;

                    }
                    checkAdmin();

            });

        });

        onBeforeUnmount(() => {

            window.removeEventListener(
                "scroll",
                handleScroll
            );
            document.removeEventListener("click", onDocumentClick);
            document.removeEventListener("keydown", onDocumentKey);

        });

        return {contentClass,
            userInfo,
            userProfile,
            profileImageStyle,
            walletText,
            doLogout,
            emitAppEvent,
            selectedProvider,
            navMenu,
            email,
            name,
            accountName,
            closeMenu,
            hasProfileImage,
            goFromMenu,
            isAdmin,
            isMenuVisible,
            logoutFromMenu,
            profileWrap,
            toggleMenu,
            getURL,
            getIcon,
            getRawIcon,
            toggleTheme,
            gotoTab,
            gotoPath,
            eBus,
            handleScroll,
            metamaskLogin,
            "icon": icon.get,
            lastScrollPosition,
            "localize": translation.localize,
            navbarBackgroundClass,
            langMenuOpen,
            currentLang,
            currentLangLabel,
            langOptions,
            switchLang,
            route,
            serverConfig,
            showLoginModal,
            showTermsModal,
            updateView,
            web3,
            eth};

    }
};

</script>

<style>

@import url('https://fonts.googleapis.com/css2?family=Space+Grotesk:wght@300;400;500;600;700&family=JetBrains+Mono:wght@400;500;600;700&display=swap');

:root {
  --purple: #7c3aed;
  --purple-deep: #5b21b6;
  --indigo: #6366f1;
  --magenta: #ec4899;
  --rose: #f43f5e;
  --cyan: #06b6d4;
  --cyan-light: #22d3ee;

  --bg-primary: #ffffff;
  --bg-secondary: #f8f7fb;
  --bg-card: #f8f7fb;
  --bg-card-hover: #f0eef5;
  --border-subtle: #e9e5f0;
  --border-hover: rgba(124, 58, 237, 0.3);
  --text-primary: #0f0d15;
  --text-secondary: #4a4458;
  --text-muted: #8b83a0;
  --accent-blue: #6366f1;
  --accent-purple: #7c3aed;
  --accent-cyan: #06b6d4;
  --gradient-primary: linear-gradient(135deg, #7c3aed 0%, #6366f1 40%, #06b6d4 100%);
  --gradient-text: linear-gradient(135deg, #7c3aed 0%, #6366f1 50%, #06b6d4 100%);
  --gradient-warm: linear-gradient(135deg, #7c3aed 0%, #ec4899 50%, #f43f5e 100%);
  --gradient-divider: linear-gradient(90deg, #ec4899, #06b6d4);
  --gradient-cta: linear-gradient(90deg, #ec4899, #06b6d4);
  --font-heading: 'Space Grotesk', system-ui, sans-serif;
  --font-body: 'Space Grotesk', system-ui, sans-serif;
  --font-mono: 'JetBrains Mono', monospace;
  --bg-navbar: rgba(255, 255, 255, 0.7);
  --bg-navbar-scroll: rgba(255, 255, 255, 0.92);
  --bg-modal: rgba(255, 255, 255, 0.96);
  --bg-overlay: rgba(15, 13, 21, 0.4);
  --bg-footer: #f8f7fb;
  --bg-dropdown: rgba(255, 255, 255, 0.96);
  --bg-input: rgba(124, 58, 237, 0.04);
  --bg-video-card: rgba(255, 255, 255, 0.85);
  --bg-video-card-hover: rgba(255, 255, 255, 0.92);
  --border-video-subtle: #e9e5f0;
  --shadow-sm: 0 2px 8px rgba(124,58,237,0.08);
  --shadow-md: 0 4px 20px rgba(124,58,237,0.12), 0 1px 4px rgba(0,0,0,0.06);
  --shadow-lg: 0 12px 40px rgba(124,58,237,0.18), 0 4px 12px rgba(0,0,0,0.08);
  --radius-sm: 6px;
  --radius-md: 12px;
  --radius-lg: 18px;
  --radius-xl: 24px;
  --glass: rgba(255,255,255,0.55);
  --glass-hover: rgba(255,255,255,0.72);
  --glass-strong: rgba(255,255,255,0.85);
  --glass-subtle: rgba(255,255,255,0.35);
  --overlay: rgba(255,255,255,0.45);
  --paper-shadow: 0 4px 16px rgba(124,58,237,0.12), 0 1px 3px rgba(0,0,0,0.06), 6px 6px 0 rgba(124,58,237,0.10);
  --paper-shadow-hover: 0 8px 32px rgba(124,58,237,0.22), 0 2px 6px rgba(0,0,0,0.08), 8px 8px 0 rgba(124,58,237,0.16);
  --cut: 22px;
}

/* ---- Dark mode ---- */
:root[data-theme="dark"] {
  --bg-primary: #0a0a12;
  --bg-secondary: #12121e;
  --bg-card: rgba(255, 255, 255, 0.04);
  --bg-card-hover: rgba(255, 255, 255, 0.07);
  --border-subtle: rgba(255, 255, 255, 0.08);
  --border-hover: rgba(124, 58, 237, 0.4);
  --text-primary: #f0eef5;
  --text-secondary: rgba(255, 255, 255, 0.6);
  --text-muted: rgba(255, 255, 255, 0.35);
  --bg-navbar: rgba(10, 10, 18, 0.7);
  --bg-navbar-scroll: rgba(10, 10, 18, 0.92);
  --bg-modal: rgba(18, 18, 30, 0.96);
  --bg-overlay: rgba(0, 0, 0, 0.7);
  --bg-footer: #0e0e18;
  --bg-dropdown: rgba(18, 18, 30, 0.96);
  --bg-input: rgba(255, 255, 255, 0.05);
  --bg-video-card: rgba(10, 10, 18, 0.8);
  --bg-video-card-hover: rgba(10, 10, 18, 0.9);
  --border-video-subtle: rgba(255, 255, 255, 0.1);
  --shadow-sm: 0 2px 8px rgba(124,58,237,0.15);
  --shadow-md: 0 4px 20px rgba(124,58,237,0.25), 0 1px 4px rgba(0,0,0,0.2);
  --shadow-lg: 0 12px 40px rgba(124,58,237,0.3), 0 4px 12px rgba(0,0,0,0.15);
  --glass: rgba(20,18,35,0.6);
  --glass-hover: rgba(30,26,55,0.75);
  --glass-strong: rgba(20,18,35,0.85);
  --glass-subtle: rgba(20,18,35,0.4);
  --overlay: rgba(10,10,18,0.45);
  --paper-shadow: 0 4px 16px rgba(124,58,237,0.25), 0 1px 3px rgba(0,0,0,0.15), 6px 6px 0 rgba(124,58,237,0.2);
  --paper-shadow-hover: 0 8px 32px rgba(124,58,237,0.4), 0 2px 6px rgba(0,0,0,0.2), 8px 8px 0 rgba(124,58,237,0.3);
}

#Nav {
  width:100%;
}
#vue-app {
  position: relative;
  height: 100%;
  font-family: var(--font-body);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-size: 16px;
  line-height: 1.6;
  scroll-behavior: smooth;
  color: var(--text-primary);
  background-color: var(--bg-primary);
}
[v-cloak] {
    display: none !important;
}
a {
  text-decoration: none;
  color: var(--accent-purple);
}
a:hover {
  color: var(--purple-deep);
}
a.nav-link {
  color: var(--text-primary);
  padding: 0;
}
a.nav-link:hover {
  cursor: pointer;
}

/* ---- Global typography ---- */
h1, h2, h3 {
  font-family: var(--font-heading);
  font-weight: 700;
}
h1, h2 {
  background: var(--gradient-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.label {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 3px;
  color: var(--accent-purple);
}
.mono {
  font-family: var(--font-mono);
}
.divider {
  height: 3px;
  border-radius: 2px;
  background: var(--gradient-divider);
}
.layout {
  width:350px;
  margin-left: auto;
  margin-right: auto;
}
#background {
  position: absolute;
  width: 100%;
  overflow: hidden;
}
.navbar {
  display: flex;
  flex-direction: column;
  padding: 10px;
  margin-left: auto;
  margin-right: auto;
  align-items: center;
  text-align: left;
  width: 100%;
  max-width: 1200px;
  z-index: 5;
}
.profile-icon {
  cursor: pointer;
  width: 56px;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}
/* An account with no picture of its own gets the knight rather than an empty
   circle. The three colours are the ones the buttons use. */
.profile-icon-empty {
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.16) 0%, rgba(6, 182, 212, 0.16) 100%);
  border: 1px solid rgba(124, 58, 237, 0.22);
  color: var(--accent-purple);
  transition: color 0.25s ease, background 0.25s ease;
}
.app-profile-frame:hover .profile-icon-empty {
  color: var(--accent-blue);
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.26) 0%, rgba(6, 182, 212, 0.24) 100%);
}
/* The knight is the brochure's own artwork, used as a mask rather than as a
   picture: the image supplies the shape and currentColor supplies the colour,
   so one black asset works on both themes and follows the hover. */
.profile-knight {
  display: block;
  width: 72%;
  height: 72%;
  background: currentColor;
  -webkit-mask: url("/public/knightmare-assets/knightlogo.png") center / contain no-repeat;
  mask: url("/public/knightmare-assets/knightlogo.png") center / contain no-repeat;
}
#header {
  position: fixed;
  width: 100%;
  transition: top .33s ease-in-out;
  -moz-transition: top .33s ease-in-out;
  -webkit-transition: top .33s ease-in-out;
  z-index: 5;
}
.header-dark {
  display: flex;
  background-color: transparent;
}
.app-container {
  display: flex;
  flex-direction: row;
  max-width: 100%;
  position: relative;
  overflow: hidden;
}
#navbar-background {
  position: fixed;
  width: 100%;
  height: 80px;
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid var(--border-subtle);
  display: flex;
  align-items: center;
}
.navbar-background-tall {
  z-index: 5;
  padding: 15px;
  transition: all .25s ease-in-out;
}
.navbar-background-short {
  z-index: 5;
  padding: 15px;
  transition: all .25s ease-in-out;
}
.top-bar-flex {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}
.flex-row-grow {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
  align-items: center;
}
.flex-row-center {
  display: flex;
  flex-direction: row;
  align-items: center;
}
.flex-row {
  display: flex;
  flex-direction: row;
}
.flex-col {
  display: flex;
  flex-direction: column;
}
.flex-col-app-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}
.center-end {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.brand-logo {
  font-family: var(--font-heading);
  font-size: 1.4em;
  font-weight: 700;
  background: var(--gradient-text);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  cursor: pointer;
  letter-spacing: -0.5px;
  margin-left: 10px;
}
.brand-ai {
  background: linear-gradient(135deg, #f472b6, #fb7185);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.navbar-item {
  color: var(--text-secondary);
  font-family: var(--font-heading);
  font-size: 0.85em;
  font-weight: 500;
  text-align: center;
  cursor: pointer;
  transition: color 0.2s ease;
  letter-spacing: -0.2px;
}
.navbar-item:hover {
  color: var(--accent-purple);
}
.menu-items {
  cursor: pointer;
  margin: 0 10px;
}
.lang-picker {
  position: relative;
  margin-right: 8px;
}
.lang-current {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--text-muted);
  cursor: pointer;
  padding: 6px 10px;
  border-radius: 6px;
  transition: color 0.2s, background 0.2s;
}
.lang-current:hover {
  color: var(--text-primary);
  background: rgba(124,58,237,0.08);
}
.lang-dropdown {
  position: absolute;
  top: 100%;
  right: 0;
  margin-top: 6px;
  background: var(--bg-primary);
  border: 1px solid var(--border-subtle);
  border-radius: 10px;
  padding: 6px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.12);
  z-index: 20;
  min-width: 56px;
}
.lang-option {
  font-family: var(--font-mono);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 1px;
  color: var(--text-secondary);
  padding: 6px 10px;
  border-radius: 6px;
  cursor: pointer;
  text-align: center;
  transition: background 0.2s, color 0.2s;
}
.lang-option:hover {
  background: rgba(124,58,237,0.1);
  color: var(--text-primary);
}
.lang-active {
  color: #7c3aed;
  background: rgba(124,58,237,0.08);
}
.theme-toggle {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 36px;
  height: 36px;
  cursor: pointer;
  border-radius: var(--radius-sm);
  color: var(--text-muted);
  transition: color 0.2s ease, background 0.2s ease;
  margin: 0 6px;
}
.theme-toggle:hover {
  color: var(--accent-purple);
  background: var(--bg-card);
}
.profile-wrap {
  position: relative;
}
/* The avatar is a button so it can be reached by keyboard and says whether the
   menu is open. The ring appears on hover and stays while it is open. */
.app-profile-frame {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  border: none;
  background: none;
  cursor: pointer;
  border-radius: 50%;
  box-shadow: 0 0 0 0 rgba(124, 58, 237, 0);
  transition: box-shadow 0.25s ease, transform 0.25s ease;
}
.app-profile-frame:hover {
  transform: translateY(-1px);
  box-shadow: 0 0 0 3px rgba(124, 58, 237, 0.22);
}
.app-profile-frame.is-open {
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.38);
}
.app-profile-frame:focus-visible {
  outline: none;
  box-shadow: 0 0 0 3px rgba(6, 182, 212, 0.5);
}
/* Opacity and transform rather than display, so it can be animated, and so a
   pointer travelling towards it is never over a gap that closes it. */
.profile-menu {
  position: absolute;
  top: calc(100% + 12px);
  right: 0;
  min-width: 220px;
  padding: 8px;
  background: var(--bg-dropdown);
  backdrop-filter: blur(20px);
  border: 1px solid var(--border-subtle);
  border-radius: 16px;
  box-shadow: 0 18px 48px rgba(10, 10, 18, 0.28);
  z-index: 40;
  opacity: 0;
  visibility: hidden;
  transform: translateY(-8px) scale(0.98);
  transform-origin: top right;
  transition: opacity 0.22s ease, transform 0.22s ease, visibility 0s linear 0.22s;
}
.profile-menu.show-menu {
  opacity: 1;
  visibility: visible;
  transform: translateY(0) scale(1);
  transition: opacity 0.22s ease, transform 0.22s ease, visibility 0s;
}
.profile-menu-who {
  padding: 8px 14px 10px;
  margin-bottom: 6px;
  font-family: var(--font-body);
  font-size: 0.82em;
  color: var(--text-secondary);
  border-bottom: 1px solid var(--border-subtle);
  overflow-wrap: anywhere;
}
.menu-item-text {
  display: block;
  width: 100%;
  padding: 10px 14px;
  border: none;
  border-radius: 10px;
  background: transparent;
  font-family: var(--font-heading);
  font-size: 0.88em;
  font-weight: 500;
  text-align: left;
  color: var(--text-primary);
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease, transform 0.2s ease;
}
.menu-item-text:hover {
  background: linear-gradient(135deg, rgba(124, 58, 237, 0.14) 0%, rgba(6, 182, 212, 0.14) 100%);
  color: var(--accent-purple);
  transform: translateX(2px);
}
.menu-item-text:focus-visible {
  outline: none;
  background: rgba(99, 102, 241, 0.16);
}
.menu-item-quiet {
  color: var(--text-secondary);
}
.menu-item-quiet:hover {
  color: var(--accent-blue);
}
.app-flex {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.top-mobile-border {
  height: 30px;
}
.desktop-content {
  width: 100%;
  padding-top: 70px;
  min-height: 80vh;
}
.mobile-content {
  width: 100%;
  padding-top: 90px;
  min-height: 80vh;
}
.component-margin {
  margin: 0;
  max-width: 100%;
  padding: 0;
}
.nav-tab-no-mobile {
  padding: 15px;
  font-size: 1.2em;
  cursor: pointer;
  color: var(--text-primary);
}
.nav-tab-no-mobile:hover {
  color: var(--accent-blue);
}
.sidebar-panel-nav {
  display: flex;
  flex-direction: column;
  background: var(--bg-primary);
}
.desktop-compact {
  padding: 20px;
}
.desktop-expand {
  padding: 20px;
}
.app-footer {
  margin-top: auto;
}
.hidden {
  display: none;
}

/* Modal styles — dark theme */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: var(--bg-overlay);
  backdrop-filter: blur(6px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}
/* The ground fades and the panel rises into it. Leaving is quicker than
   arriving, because a dialog being dismissed should not be waited for. */
.modal-enter-active {
  transition: opacity 0.28s ease;
}
.modal-leave-active {
  transition: opacity 0.2s ease;
}
.modal-enter-from,
.modal-leave-to {
  opacity: 0;
}
.modal-enter-active .modal-container {
  transition: transform 0.32s cubic-bezier(0.2, 0.8, 0.3, 1), opacity 0.32s ease;
}
.modal-leave-active .modal-container {
  transition: transform 0.2s ease, opacity 0.2s ease;
}
.modal-enter-from .modal-container,
.modal-leave-to .modal-container {
  opacity: 0;
  transform: translateY(16px) scale(0.97);
}
/* The gradient is on a strip across the top rather than a bar down one side:
   the same three colours as the buttons inside, where the eye arrives first. */
.modal-container {
  position: relative;
  background: var(--bg-modal);
  backdrop-filter: blur(24px);
  border: 1px solid var(--border-subtle);
  border-radius: 20px;
  max-width: 460px;
  width: 90%;
  max-height: 84vh;
  overflow-y: auto;
  overflow-x: hidden;
  box-shadow: 0 28px 80px rgba(10, 10, 18, 0.35);
}
.modal-container::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 3px;
  background: linear-gradient(90deg, #7c3aed 0%, #6366f1 45%, #06b6d4 100%);
}
.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 26px 28px 18px;
  font-family: var(--font-heading);
  font-size: 1.35em;
  font-weight: 700;
  letter-spacing: -0.3px;
  color: var(--text-primary);
}
.modal-close {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 34px;
  height: 34px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 1.4em;
  line-height: 1;
  color: var(--text-secondary);
  transition: color 0.25s ease, background 0.25s ease, transform 0.25s ease;
}
.modal-close:hover {
  color: var(--text-primary);
  background: rgba(124, 58, 237, 0.12);
  transform: rotate(90deg);
}
.modal-body {
  padding: 4px 28px 30px;
}
.connect-text {
  margin-bottom: 20px;
  color: var(--text-secondary);
}
.connect-wallets {
  margin-bottom: 20px;
}
.wallet-select-container {
  display: flex;
  flex-wrap: wrap;
  gap: 15px;
  justify-content: center;
}
.connect-img-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 15px;
  border: 1px solid var(--border-subtle);
  border-radius: 4px;
  cursor: pointer;
  transition: all .2s ease;
}
.connect-img-container:hover {
  border-color: var(--border-hover);
  box-shadow: 0 4px 20px rgba(59, 130, 246, 0.15);
}
.connect-img {
  width: 48px;
  height: 48px;
  margin-bottom: 8px;
}
.wallet-text-desktop {
  font-size: 0.9em;
  color: var(--text-primary);
}
.wallet-text-mobile {
  font-size: 0.8em;
  color: var(--text-primary);
}

/* Route transitions */
.route-enter-active,
.route-leave-active {
  transition: opacity 0.2s ease;
}
.route-enter-from,
.route-leave-to {
  opacity: 0;
}

/* =======================================================
   RTL SUPPORT (Arabic) — per-element, not global dir
   ======================================================= */
.is-rtl .navbar-item { direction: rtl; text-align: right; }

</style>
